'use strict';

customerZone

.component('otherOperatorSelect', {
    bindings: {
        id: '@',
        name: '@',
        ngModel: '=',
        ngRequired: '='
    },
    templateUrl: customerZone.fromBase('components/other-operators/other-operators-select.component.html'),
    controller: ['$log', 'UnleashedClient', 'config', 'utils', function($log, api, config, utils){

        var vm = this;

        vm.operators = {};

        vm.$onInit = function(){
            api.getOperators()
                .then(function(operators){
                    vm.operators = operators
                        .filter(notJim);
                    setCanonicalVersion();
                })
                .catch(function(error){
                    $log.error('Could not load operator listing', error);
                    utils.showError();
                });
        };

        vm.$onChanges = function(){
            setCanonicalVersion();
        };

        /**
         * Make sure the same copy of the operator entity is used in the model as in the list.  This avoids problems
         * when the entity is loaded on a different source and incorrectly displayed.
         */
        var setCanonicalVersion = function(){
            if (!vm.ngModel) return;
            var fromList = vm.operators.filter(function(op){ return op.id === vm.ngModel.id; })[0];
            if (fromList !== vm.ngModel) vm.ngModel = fromList;
        };

        var notJim = function(operator){
            return operator.name !== 'JIM Mobile';
        };
    }],
    controllerAs: 'vm'
});
